import PaymentForm from "../PaymentForm"

const Checkout = ({stripePromise, checkoutMeta, grandTotal, onCheckoutMetaChange,
    cartState, setCartState, paymentMethod, setPaymentMethod, setError, setLoading, customerInfo, setCustomerInfo, setCart
}) => {
    return <PaymentForm stripePromise={stripePromise} checkoutMeta={checkoutMeta} grandTotal={grandTotal} onCheckoutMetaChange={onCheckoutMetaChange}
                cartState={cartState} setCartState={setCartState} paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod} setError={setError} setLoading={setLoading}
                customerInfo={customerInfo} setCustomerInfo={setCustomerInfo} setCart={setCart}/>
}

export default Checkout